import React, { useContext, useState } from 'react';
import { DownloadOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import {
  addDeviceFilters,
  buildDeviceFilters,
} from '@totem/components/devices/devicesContainer/utilities';
import OsPatchReportContext from '@totem/components/osPatchReport/osPatchReportContext';
import { Params } from '@totem/types/common';
import { DeviceFilters } from '@totem/types/devices';
import api from '@totem/utilities/api';
import { DEVICES_ENDPOINT } from '@totem/utilities/endpoints';
import fileUtilities from '@totem/utilities/fileUtilities';

type Props = {
  staticFilters?: DeviceFilters;
};

const OSPatchExportButton = ({ staticFilters }: Props) => {
  const [loading, setLoading] = useState<boolean>(false);
  const { input } = useContext(OsPatchReportContext);

  const buildParameters = () => {
    const params: Params = {
      paging: {
        page: input.page,
        pageSize: input.pageSize,
      },
      sort: {
        field: input.sortField,
        direction: +input.sortDirection,
      },
      filters: buildDeviceFilters(input),
    };

    params.filters = addDeviceFilters(params.filters, staticFilters);

    return params;
  };

  const exportData = async () => {
    setLoading(true);

    const params = buildParameters();

    const uri = `${DEVICES_ENDPOINT}/osPatchReport/export`;

    const { data } = await api.post(`${uri}`, params);
    fileUtilities.downloadFile('osPatchInstalls', data);

    setLoading(false);
  };

  return (
    <Button
      type="default"
      icon={<DownloadOutlined />}
      onClick={exportData}
      loading={loading}
    >
      Export CSV
    </Button>
  );
};

export default OSPatchExportButton;
